mutation CommunicationGroupDelete($input: CommunicationGroupDeleteInput!) {
  communicationGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
